import { connect } from 'react-redux';
import SetPasswordView from './SetPasswordView';
import { setPassword, setPasswordFormLoaded } from '../../actions';

const mapStateToProps = (state) => ({
  ...state.resetPassword,
  isLoading: state.request.SET_PASSWORD_REQUEST || state.request.NEX_USERNAME_AUTH_REQUEST,
});

export default connect(mapStateToProps, {
  setPassword,
  setPasswordFormLoaded,
})(SetPasswordView);
